module.exports = __webpack_public_path__ + "img/GAME_GLACIER2.3a0a6f01.jpg";